import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    IconButton,
    Menu,
    MenuItem,
    Checkbox,
    Typography,
    Button,
    TextField,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

import SideNav from '../../common/SideNav';
import RuleEditor from '../../common/RuleEditor';
import ConfirmDialog from '../../common/ConfirmDialog';
import {
    hasSideBar,
    toggleSideBar,
    updateCurrentComponent,
} from '../../../store/actions/navActions';
import {
    hideLoading,
    showLoading,
} from '../../../store/actions/loadingActions';
import {
    notify,
    notifyError,
    notifySuccess,
} from '../../../store/actions/notificationActions';
// import { getRuleList } from '../../../services/api/ruleApi';
import {
    extractEvent,
    extractEventAttribute,
} from '../../../services/ruleUtils';
import {
    asString,
    capitalizeFirstLetter,
    nonEmptyString,
    toUpperCase,
} from '../../../services/typeUtils';
import { formatDate } from '../../../services/formatUtils';
import { Email } from '../../../services/Email';
import * as C from '../../../services/constants';
import {
    createRule,
    deleteRule,
    getRule,
    getRuleList,
    updateRule,
    // testRule,
} from '../../../services/api/nbaApi';

// ...existing imports...

const manageRulesTableHeader = {
    status: 'Status',
    //nbaRuleId: 'Rule Id',
    ruleAppliesTo: 'Rule Id',
    // subcategory: 'Subcategory',
    description: 'Rule Name',
    frequency: 'Frequency',
    loadType: 'Load Type',
    nextRun: 'Next Run',
    json: 'JSON',
    actions: 'Actions',
};

// const statusOptions = ['activee', 'inactive'];
// const statusOptions = ['active', 'inactive'];
const statusOptions = ['published', 'draft', 'expired'];
const ruleAppliesToOptions = [
    'consumer',
    'article',
    'game',
    'video',
    'quiz',
    'raffle',
    'user tier',
];

const CollapsibleJSON = ({ query }) => {
    const [expanded, setExpanded] = React.useState(false);

    const toggleExpanded = () => setExpanded((prev) => !prev);

    return (
        <Box
            sx={{
                wordWrap: 'break-word',
                border: '1px solid #ccc',
                borderRadius: 4,
                padding: 1,
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <Typography
                variant="body2"
                component="div"
                sx={{
                    maxWidth: 300,
                    maxHeight: expanded ? 'none' : '1.5em',
                    overflow: expanded ? 'visible' : 'hidden',
                    textOverflow: expanded ? 'clip' : 'ellipsis',
                    whiteSpace: expanded ? 'normal' : 'nowrap',
                }}
            >
                {query}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'end',
                }}
            >
                <Button
                    size="small"
                    variant="text"
                    onClick={toggleExpanded}
                    sx={{ textTransform: 'none', width: '80px' }}
                >
                    {expanded ? 'Show Less' : 'Show More'}
                </Button>
            </Box>
        </Box>
    );
};

const ManageRules = () => {
    const dispatch = useDispatch();
    const fields = Object.keys(manageRulesTableHeader);
    const { market, category, brand } = useSelector((state) => state.auth.user);

    const [holdDataForSearch, setHoldDataForSearch] = useState([]);
    const [rules, setRules] = useState([]);
    const [ruleId, setRuleId] = useState(null);
    const [showRuleEditor, setShowRuleEditor] = useState(false);
    const [type, setType] = useState(C.RULE_TYPE_NEW);
    const [page, setPage] = useState(0);
    const [sortBy, setSortBy] = useState('status');
    // const [sortOrder, setSortOrder] = useState('asc');
    const [sortOrder, setSortOrder] = useState('desc');

    const [filterStatus, setFilterStatus] = useState([]);
    const [filterRuleAppliesTo, setFilterRuleAppliesTo] = useState([]);
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [anchorElRuleAppliesTo, setAnchorElRuleAppliesTo] = useState(null);
    // const [mvelExpressionSearch, setMVELExpressionSearch] = useState('');
    // const [sqlQuerySearch, setSqlQuerySearch] = useState('');
    const [jsonSearch, setJsonSearch] = useState('');
    const [confirmDialog, setConfirmDialog] = useState({
        display: false,
        title: '',
        message: '',
        note: '',
        onClose: null,
        onConfirm: null,
        confirmText: '',
        backText: '',
    });

    //      const dummyRules = [
    //     {
    //         nbaRuleId: '1',
    //         status: 'active',
    //         ruleAppliesTo: 'consumer',
    //         ruleType: 'type1',
    //         description: 'Send daily summary email to all consumers.',
    //         subcategory: 'p1',
    //         frequency: 'daily',
    //         loadType: 'full',
    //         nextRun: '2025-08-26',
    //         sqlQuery: 'SELECT * FROM users WHERE subscribed = 1;',
    //     },
    //     {
    //         nbaRuleId: '2',
    //         status: 'inactive',
    //         ruleAppliesTo: 'article',
    //         ruleType: 'type2',
    //         description: 'Weekly article engagement report.',
    //         subcategory: 'p2',
    //         frequency: 'weekly',
    //         loadType: 'delta',
    //         nextRun: '2025-08-31',
    //         sqlQuery: 'SELECT article_id, COUNT(*) FROM article_views GROUP BY article_id;',
    //     },
    //     {
    //         nbaRuleId: '3',
    //         status: 'active',
    //         ruleAppliesTo: 'quiz',
    //         ruleType: 'type3',
    //         description: 'Monthly quiz participation stats.',
    //         subcategory: 'p3',
    //         frequency: 'monthly',
    //         loadType: 'full',
    //         nextRun: '2025-09-01',
    //         sqlQuery: 'SELECT quiz_id, COUNT(*) FROM quiz_attempts GROUP BY quiz_id;',
    //     },
    // ];

    const handlePageChange = (event, page) => {
        setPage(page);
    };

    const openRuleEditor = (status, ruleId = null) => {
        setRuleId(ruleId);
        setType(status);
        setShowRuleEditor(true);
    };

    const closeRuleEditor = () => {
        setRuleId(null);
        setShowRuleEditor(false);
    };

    useEffect(() => {
        // setHoldDataForSearch(existingRules);
        // setRules(existingRules);

        dispatch(updateCurrentComponent(C.APP_MANAGE_RULES_PAGE_TITLE));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));

        dispatch(showLoading());
        getRuleList(market)
            .then((response) => {
                console.log('API response:', response.data); //mycode
                const existingRules = response.data.map((rule) => ({
                    nbaRuleId: rule.nbaRuleId,
                    status: rule.status,
                    ruleAppliesTo: asString(rule.nbaRuleId),
                    ruleType: rule.namespace,
                    description: rule.description,
                    frequency: rule.frequency,
                    loadType: rule.loadType,
                    nextRun: rule.nextRun,
                    json: rule.json,
                    // condition: rule.condition || '', // Add this
                    // action: rule.action || '', // Add this
                }));

                const dummyRule = {
                nbaRuleId: 'DUMMY-001',
                status: 'PUBLISHED',
                ruleAppliesTo: 'consumer',
                ruleType: 'POINT',
                description: 'Sample rule for testing purposes',
                frequency: 'DAILY',
                loadType: 'FULL',
                nextRun: '2025-01-20',
                json: '{"condition": "user.age > 18", "action": "award_points", "points": 100}',
            };
                const rulesWithDummy = [...existingRules, dummyRule];
                // setHoldDataForSearch(existingRules);
                // setRules(existingRules);
                setHoldDataForSearch(rulesWithDummy);
                setRules(rulesWithDummy);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(hideLoading()));
    }, [showRuleEditor]);

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(field);
            setSortOrder('asc');
        }
    };

    const handleFilterStatus = (event) => {
        const { checked, value } = event.target;
        setFilterStatus((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    const handleFilterRuleAppliesTo = (event) => {
        const { checked, value } = event.target;
        setFilterRuleAppliesTo((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    const filteredAndSortedRules = rules
        .filter((rule) => {
            return (
                filterStatus.length === 0 ||
                filterStatus.includes(rule.status.toLowerCase())
            );
        })
        .filter((rule) => {
            return (
                filterRuleAppliesTo.length === 0 ||
                filterRuleAppliesTo.includes(rule.ruleAppliesTo.toLowerCase())
            );
        })
        .sort((a, b) => {
            if (sortOrder === 'asc') {
                return a[sortBy].toLowerCase() > b[sortBy].toLowerCase()
                    ? 1
                    : -1;
            }
            return a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
        });

    //mycode from here
    // const handleEdit = (rule) => {
    //     openRuleEditor(C.RULE_TYPE_ACTIVE, rule.nbaRuleId);
    // };

    const handleEdit = (rule) => {
        openRuleEditor(C.RULE_TYPE_PUBLISHED, rule.nbaRuleId);
    };

    // const handleDeactivate = (rule) => {
    //     // Call an API to deactivate the rule here
    //     // For now, just update status locally
    //     setRules((prevRules) =>
    //         prevRules.map((r) =>
    //             r.nbaRuleId === rule.nbaRuleId
    //                 ? { ...r, status: C.RULE_TYPE_DRAFT}
    //                 : r
    //         )
    //     );
    // };

    //

   const handleExpireOrPublish = (rule) => {
    if (rule.status === C.RULE_TYPE_EXPIRED) {
        // Handle Publish for expired rules
        dispatch(showLoading());
        getRule(market, rule.nbaRuleId)
            .then((response) => {
                const fullRule = response?.data;
                const newRuleBody = {
                    namespace: fullRule.namespace ,
                    description: fullRule.description,
                    condition: fullRule.condition,
                    action: fullRule.action,
                    status: 'PUBLISHED',
                };
                // First create the new rule
                return createRule(market, newRuleBody);
            })
            .then((createResponse) => {
                // Then delete the expired rule
                return deleteRule(market, rule.nbaRuleId);
            })
            .then(() => {
                // Refresh rule list
                return getRuleList(market);
            })
            .then((response) => {
                const existingRules = response.data.map((rule) => ({
                    nbaRuleId: rule.nbaRuleId,
                    status: rule.status,
                    ruleAppliesTo: asString(rule.nbaRuleId),
                    ruleType: rule.namespace,
                    description: rule.description,
                    frequency: rule.frequency,
                    loadType: rule.loadType,
                    nextRun: rule.nextRun,
                    json: rule.json,
                }));
                setHoldDataForSearch(existingRules);
                setRules(existingRules);
                dispatch(notifySuccess('Published!', 'New rule created and expired rule removed successfully.'));
            })
            .catch((error) => {
                console.error('Publish error:', error);
                dispatch(notifyError('Error!', 'Unable to publish rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    } else {
        // Handle Expire for published rules
        dispatch(showLoading());
        getRule(market, rule.nbaRuleId)
            .then((response) => {
                const fullRule = response?.data;
                const ruleBody = {
                    description: fullRule.description,
                    condition: fullRule.condition,
                    action: fullRule.action,
                    status: 'EXPIRED',
                };
                return updateRule(market, rule.nbaRuleId, ruleBody);
            })
            .then(() => {
                setRules(prevRules => prevRules.map(r => 
                    r.nbaRuleId === rule.nbaRuleId ? { ...r, status: C.RULE_TYPE_EXPIRED } : r
                ));
                setHoldDataForSearch(prevRules => prevRules.map(r => 
                    r.nbaRuleId === rule.nbaRuleId ? { ...r, status: C.RULE_TYPE_EXPIRED } : r
                ));
                dispatch(notifySuccess('Rule Expired!', 'The rule has been successfully expired.'));
            })
            .catch((error) => {
                console.error('Expire error:', error);
                dispatch(notifyError('Error!', 'Unable to expire rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    }
};
    //

    const handleDelete = (rule) => {
        console.log('Attempting to delete rule:', rule);

        if (rule.status === C.RULE_TYPE_PUBLISHED) {
            dispatch(
                notifyError(
                    'Cannot Delete!',
                    'Please expire the rule before deleting.'
                )
            );
            return;
        }

        setConfirmDialog({
            display: true,
            title: 'Confirm: Delete Rule',
            message: 'Are you sure you want to delete this rule?',
            onConfirm: () => removeRule(rule),
            onClose: closeConfirmDialog,
            confirmText: 'Yes, Delete Rule',
            backText: 'No, Continue',
        });
    };

    const removeRule = (rule) => {
        console.log('Deleting rule:', rule);
        dispatch(showLoading());
        deleteRule(market, rule.nbaRuleId)
            .then((response) => {
                setRules((prevRules) =>
                    prevRules.filter((r) => r.nbaRuleId !== rule.nbaRuleId)
                );
                dispatch(
                    notify(
                        'Deleted Rule!',
                        'Rule has been successfully deleted.'
                    )
                );
                closeConfirmDialog();
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to delete rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    };

    const closeConfirmDialog = () => {
        setConfirmDialog({ ...confirmDialog, display: false });
    };


    const handleTestRule = (rule) => {
        console.log('Testing rule:', rule.nbaRuleId);
        //  dispatch(showLoading());
        // Assuming there's a test/validate API endpoint
        // Add test rule logic here
    };
    //my code till here

    const renderFieldContent = (field, rule) => {
        if (field === C.RULE_PROPERTY_STATUS) {
            switch (rule[field]) {
                case C.RULE_TYPE_PUBLISHED:
                    return (
                        <span
                            className="view-rule published"
                            onClick={() =>
                                rule.ruleType !== C.RULE_FOR_TIER &&
                                openRuleEditor(
                                    C.RULE_TYPE_PUBLISHED,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Published
                        </span>
                    );
                case C.RULE_TYPE_DRAFT:
                    return (
                        <span
                            className="view-rule draft"
                            onClick={() =>
                                openRuleEditor(
                                    C.RULE_TYPE_DRAFT,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Draft
                        </span>
                    );

                case C.RULE_TYPE_EXPIRED:
                    return (
                        <span
                            className="view-rule expired"
                            onClick={() =>
                                openRuleEditor(
                                    C.RULE_TYPE_EXPIRED,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            Expired
                        </span>
                    );
                default:
                    return '-';
                //         }
                // }

                // case C.RULE_TYPE_ACTIVE:
                //     return (
                //         <span
                //             className="view-rule published"

                //             onClick={() =>
                //                 rule.ruleType !== C.RULE_FOR_TIER &&
                //                 openRuleEditor(
                //                     C.RULE_TYPE_ACTIVE,
                //                     rule.nbaRuleId
                //                 )
                //             }
                //         >
                //             Active
                //         </span>
                //     );
                // case C.RULE_TYPE_INACTIVE:
                //     return (
                //         <span
                //             className="view-rule draft"
                //             onClick={() =>
                //                 openRuleEditor(
                //                     C.RULE_TYPE_INACTIVE,
                //                     rule.nbaRuleId
                //                 )
                //             }
                //         >
                //             Inactive
                //         </span>
                //     );
                // default:
                //     return '-';
            }
        }
       
        else if (field === C.RULE_PROPERTY_PUBLISHED_DATE) {
            if (rule[C.RULE_PROPERTY_STATUS] === C.RULE_TYPE_PUBLISHED) {
                return nonEmptyString(rule[field]) && rule[field];
            } else {
                return '-';
            }
        } else if (field === C.RULE_PROPERTY_JSON) {
            return <CollapsibleJSON key={rule.nbaRuleId} query={rule[field]} />;
        } else if (nonEmptyString(rule[field])) {
            return rule[field];
        } else if (field === C.RULE_PROPERTY_ACTIONS || field === 'actions') {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '8px',
                    }}
                >
                    <Button
                        className={`publish-rule active`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleTestRule(rule)}
                    >
                        Test Rule
                    </Button>

                    <Button
                        className={`save-rule active`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleEdit(rule)}
                    >
                        Edit
                    </Button>
                  

                   <Button
                        className={`save-rule ${
                            rule.status === C.RULE_TYPE_DRAFT
                                ? 'inactive'
                                : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleExpireOrPublish(rule)}
                        disabled={rule.status === C.RULE_TYPE_DRAFT}
                    >
                        {rule.status === C.RULE_TYPE_EXPIRED
                            ? 'Publish'
                            : 'Expire'}
                    </Button>

                       <Button
                        className={`delete-rule ${
                            rule.status === C.RULE_TYPE_PUBLISHED
                                ? 'inactive'
                                : 'active'
                        }`}
                        style={{
                            textTransform: 'none',
                            justifyContent: 'flex-start',
                        }}
                        onClick={() => handleDelete(rule)}
                        disabled={rule.status === C.RULE_TYPE_PUBLISHED}
                    >
                        Delete
                    </Button>
                </div>
            );
        } else {
            return '-';
        }
    };



    const handleSearch = () => {
        if (!jsonSearch.trim()) {
            setRules(holdDataForSearch);
        } else {
            const filteredData = holdDataForSearch.filter((row) =>
                row['json']?.toLowerCase().includes(jsonSearch.toLowerCase())
            );
            setRules(filteredData);
        }
    };

    const renderField = (field) => {
        const commonHeader = <>{manageRulesTableHeader[field]}</>;

        if (field === 'json') {
            return (
                <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    {commonHeader}
                    <div
                        className="search-container"
                        style={{ margin: '10px' }}
                    >
                        <input
                            type="text"
                            placeholder="Search"
                            className="search-box"
                            onChange={(e) => setJsonSearch(e.target.value)}
                        />
                        <SearchIcon
                            className="search-icon"
                            onClick={handleSearch}
                        />
                    </div>
                </Box>
            );
        }
        return commonHeader;
    };

    return (
        <div className="component-container-root">
            <SideNav />
            {showRuleEditor ? (
                <RuleEditor
                    status={showRuleEditor}
                    type={type}
                    ruleId={ruleId}
                    onClose={closeRuleEditor}
                    origin={C.RULE_EDITOR_MANAGE_PROGRAM}
                />
            ) : (
                <Box className="manage-rules-container component-container">
                    <p className="instruction">
                        View and manage the rules of the nba program. Go to '
                        <Link to="/help">Help page</Link>' for information on
                        how to manage.
                    </p>
                    <div
                        className="manage-rules"
                        style={{ textWrap: 'nowrap' }}
                    >
                        <TableContainer className="table-container">
                            <Table className="table">
                                <TableHead className="table-head">
                                    <TableRow className="table-row">
                                        {fields.map((field, idx) => (
                                            <TableCell
                                                key={idx}
                                                className={`table-cell ${
                                                    field ===
                                                    C.RULE_PROPERTY_JSON
                                                        ? // ? 'mvelExpressionCell'
                                                          'jsonCell'
                                                        : ''
                                                }`}
                                            >
                                                {renderField(field)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody className="table-body">
                                    {filteredAndSortedRules
                                        .slice(page * 10, page * 10 + 10)
                                        .map((rule, rowIndex) => (
                                            <TableRow
                                                key={rowIndex}
                                                className={`table-row ${
                                                    rule.ruleType ===
                                                    C.RULE_FOR_TIER
                                                        ? 'tier-rule'
                                                        : 'point-rule'
                                                }`}
                                            >
                                                {fields.map((field, idx) =>
                                                    field === 'description' ? (
                                                        <TableCell
                                                            key={idx}
                                                            className="table-cell"
                                                            style={{
                                                                whiteSpace:
                                                                    'normal',
                                                                wordBreak:
                                                                    'break-word',
                                                                maxWidth: 250,
                                                            }}
                                                        >
                                                            {renderFieldContent(
                                                                field,
                                                                rule
                                                            )}
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell
                                                            key={idx}
                                                            className="table-cell"
                                                        >
                                                            {renderFieldContent(
                                                                field,
                                                                rule
                                                            )}
                                                        </TableCell>
                                                    )
                                                )}
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <div className="table-footer">
                                <button
                                    className="add-rule"
                                    onClick={() =>
                                        openRuleEditor(C.RULE_TYPE_NEW)
                                    }
                                >
                                    + Add Rule
                                </button>
                                <TablePagination
                                    component="div"
                                    count={filteredAndSortedRules.length}
                                    rowsPerPage={10}
                                    rowsPerPageOptions={[]}
                                    page={page}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </TableContainer>
                    </div>
                </Box>
            )}
            {confirmDialog.display && (
                <ConfirmDialog
                    title={confirmDialog.title}
                    message={confirmDialog.message}
                    note={confirmDialog.note}
                    onClose={confirmDialog.onClose}
                    onConfirm={confirmDialog.onConfirm}
                    confirmText={confirmDialog.confirmText}
                    backText={confirmDialog.backText}
                />
            )}
        </div>
    );
};

export default ManageRules;
